var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStart2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_11620",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.757812 0.307373H75.253V74.8026H0.757812V0.307373Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_11620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.253 36.023H45.9893L73.149 25.1471L72.017 22.2871L44.3933 33.339L65.4331 12.3032L63.2571 10.1273L42.5614 30.823L54.0812 3.93133L51.2653 2.70735L39.5374 30.047V0.307373H36.4694V29.5711L25.5935 2.41135L22.7336 3.54334L33.7855 31.167L12.7497 10.1273L10.5737 12.3032L31.2695 32.999L4.37777 21.4791L3.15379 24.2951L30.4935 36.023H0.757812V39.091H30.0175L2.85779 49.9668L3.98978 52.8268L31.6135 41.7749L10.5737 62.8107L12.7497 64.9867L33.4455 44.2909L21.9256 71.1826L24.7416 72.4066L36.4694 45.0669V74.8026H39.5374V45.5429L50.4133 72.7026L53.2732 71.5706L42.2214 43.9469L63.2571 64.9867L65.4331 62.8107L44.7373 42.1149L71.629 53.6348L72.853 50.8188L45.5133 39.091H75.253V36.023Z",
    fill: "#F15B1B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart2);
export default __webpack_public_path__ + "static/media/start2.9e21c6d658fd8e5f68f6e6976d8f98ef.svg";
export { ForwardRef as ReactComponent };